import { style, keyframes } from '@vanilla-extract/css'

import { getRgba } from '~/styles/mixins/color.css'
import { getFontSize } from '~/styles/mixins/font.css'
import { getMarginListItems, getPaddingListItem } from '~/styles/mixins/list.css'
import { getMediaQuery } from '~/styles/mixins/mediaQuery.css'
import { cssVariables } from '~/styles/variables/cssVariables.css'

export const homeLeftColumn = style({
  '@media': {
    [getMediaQuery('md')]: {
      paddingBottom: 80,
    },
  },
})

export const homeLeftColumn_inner = style({
  '@media': {
    [getMediaQuery('md')]: {
      selectors: {
        '&:not(:root)': {
          paddingRight: 40,
          marginRight: 0,
          maxWidth: `calc((${cssVariables.layout.inner.width.large} / 2) + (${cssVariables.layout.inner.padding.md} * 2))`,
        },
      },
    },
  },
})

export const homeMainVisual = style({
  position: 'relative',
  overflow: 'hidden',
  padding: '40px 0 80px',

  '@media': {
    [getMediaQuery('md')]: {
      padding: '80px 0 120px',
    },
  },
})

export const homeMainVisual_wrapper = style({
  position: 'relative',
  zIndex: 2,
})

export const homeMainVisual_container = style({})

export const homeMainVisualImage = style({
  width: '80%',
  maxWidth: 340,
  position: 'absolute',
  bottom: 0,
  right: 0,
  zIndex: 1,
})

export const homeMainVisualImage_image = style({})

export const homeMainVisualTitle = style({
  marginTop: 24,
})

export const homeMainVisualTitle_emphasis = style({
  color: cssVariables.color.greenHaze.hex,
  fontFamily: cssVariables.font.family.en,
  fontWeight: cssVariables.font.weight.medium,
  fontSize: getFontSize(40),
  lineHeight: 1,

  '@media': {
    [getMediaQuery('sm')]: {
      fontSize: getFontSize(48),
    },

    [getMediaQuery('md')]: {
      fontSize: getFontSize(64),
    },
  },
})

export const homeMainVisual_lead = style({
  marginTop: 8,
  fontSize: getFontSize(14),
})

export const homeMainVisualRegister = style({
  marginTop: 24,
  display: 'flex',
})

export const homeMainVisualRegister_button = style({})

export const homeConcept = style({
  padding: '80px 0 40px',
  overflow: 'hidden',
})

export const homeConcept_container = style({})

export const homeConcept_title = style({})

export const homeConcept_paragraph = style({
  marginTop: 16,
  position: 'relative',
  zIndex: 2,
})

export const homeConceptDescription = style({
  position: 'relative',
  zIndex: 1,
  paddingTop: 80,
})

export const homeConceptDescriptionIllustration = style({
  position: 'relative',
  marginLeft: -56,

  '@media': {
    [getMediaQuery('xxl')]: {
      marginLeft: 0,
    },
  },
})

const homeConceptDescriptionIllustrationBackgroundPositionTop = -80

export const homeConceptDescriptionIllustration_background = style({
  display: 'block',
  aspectRatio: '1 / 1',
  width: 288,
  backgroundColor: cssVariables.color.luckyPoint.hex,
  borderRadius: 1000,
  position: 'absolute',
  top: homeConceptDescriptionIllustrationBackgroundPositionTop,
  left: -120,
  zIndex: 1,
})

export const homeConceptDescriptionIllustration_moon = style({
  display: 'block',
  aspectRatio: '1 / 1',
  width: 46,
  backgroundColor: cssVariables.color.parisDaisy.hex,
  borderRadius: 1000,
  position: 'absolute',
  top: homeConceptDescriptionIllustrationBackgroundPositionTop + 60,
  left: 96,
  zIndex: 3,
})

export const homeConceptDescriptionIllustration_stars = style({})

const animationHomeConceptDescriptionIllustration_star = keyframes({
  '0%': {
    opacity: 1,
  },
  '50%': {
    opacity: 0,
  },
  '100%': {
    opacity: 1,
  },
})

export const homeConceptDescriptionIllustration_star = style({
  display: 'block',
  aspectRatio: '1 / 1',
  width: 3,
  backgroundColor: cssVariables.color.white.hex,
  borderRadius: 1000,
  position: 'absolute',
  zIndex: 2,

  selectors: {
    [`${homeConceptDescriptionIllustration_stars} > &:nth-of-type(1)`]: {
      top: homeConceptDescriptionIllustrationBackgroundPositionTop + 22,
      left: 64,
      animation: `${animationHomeConceptDescriptionIllustration_star} 3s infinite 1s`,
    },
    [`${homeConceptDescriptionIllustration_stars} > &:nth-of-type(2)`]: {
      top: homeConceptDescriptionIllustrationBackgroundPositionTop + 24,
      left: 32,
      animation: `${animationHomeConceptDescriptionIllustration_star} 4s infinite 3s`,
    },
    [`${homeConceptDescriptionIllustration_stars} > &:nth-of-type(3)`]: {
      top: homeConceptDescriptionIllustrationBackgroundPositionTop + 46,
      left: 66,
      animation: `${animationHomeConceptDescriptionIllustration_star} 2s infinite 5s`,
    },
    [`${homeConceptDescriptionIllustration_stars} > &:nth-of-type(4)`]: {
      top: homeConceptDescriptionIllustrationBackgroundPositionTop + 48,
      left: 24,
      animation: `${animationHomeConceptDescriptionIllustration_star} 4s infinite 7s`,
    },
    [`${homeConceptDescriptionIllustration_stars} > &:nth-of-type(5)`]: {
      top: homeConceptDescriptionIllustrationBackgroundPositionTop + 62,
      left: 78,
      animation: `${animationHomeConceptDescriptionIllustration_star} 3s infinite 9s`,
    },
    [`${homeConceptDescriptionIllustration_stars} > &:nth-of-type(6)`]: {
      top: homeConceptDescriptionIllustrationBackgroundPositionTop + 74,
      left: 18,
      animation: `${animationHomeConceptDescriptionIllustration_star} 2s infinite 10s`,
    },
    [`${homeConceptDescriptionIllustration_stars} > &:nth-of-type(7)`]: {
      top: homeConceptDescriptionIllustrationBackgroundPositionTop + 94,
      left: 42,
      animation: `${animationHomeConceptDescriptionIllustration_star} 3s infinite 8s`,
    },
    [`${homeConceptDescriptionIllustration_stars} > &:nth-of-type(8)`]: {
      top: homeConceptDescriptionIllustrationBackgroundPositionTop + 128,
      left: 120,
      animation: `${animationHomeConceptDescriptionIllustration_star} 4s infinite 6s`,
    },
    [`${homeConceptDescriptionIllustration_stars} > &:nth-of-type(9)`]: {
      top: homeConceptDescriptionIllustrationBackgroundPositionTop + 140,
      left: 52,
      animation: `${animationHomeConceptDescriptionIllustration_star} 3s infinite 4s`,
    },
    [`${homeConceptDescriptionIllustration_stars} > &:nth-of-type(10)`]: {
      top: homeConceptDescriptionIllustrationBackgroundPositionTop + 166,
      left: 64,
      animation: `${animationHomeConceptDescriptionIllustration_star} 5s infinite 2s`,
    },
  },
})

export const homeConceptDescriptionIllustration_arrowTop = style({
  position: 'absolute',
  top: homeConceptDescriptionIllustrationBackgroundPositionTop + 94,
  left: 102,
  zIndex: 5,
  width: 15,
  height: 'auto',
})

const animationHomeConceptDescriptionIllustration_rocket = keyframes({
  '0%': {
    transform: 'translate(0, 0)',
  },
  '50%': {
    transform: 'translate(0, 16px)',
  },
  '100%': {
    transform: 'translate(0, 0)',
  },
})

export const homeConceptDescriptionIllustration_rocket = style({
  position: 'absolute',
  top: homeConceptDescriptionIllustrationBackgroundPositionTop + 90,
  left: 82,
  zIndex: 6,
  width: 48,
  height: 'auto',
  animation: `${animationHomeConceptDescriptionIllustration_rocket} 6s infinite`,
})

export const homeConceptDescriptionList = style({})

export const homeConceptDescriptionList_items = style({
  display: 'grid',
  gridTemplateColumns: 'repeat(1, 1fr)',
  columnGap: 0,
  rowGap: 24,
})

export const homeConceptDescriptionList_item = style({
  paddingLeft: 56,
  position: 'relative',

  '@media': {
    [getMediaQuery('xxl')]: {
      paddingLeft: 104,
    },
  },
})

const animationhomeConceptDescriptionList_contentsAfter = keyframes({
  '0%': {
    backgroundPosition: '0 0',
  },
  '100%': {
    backgroundPosition: '200% 0',
  },
})

export const homeConceptDescriptionList_contents = style({
  paddingLeft: 48,
  position: 'relative',

  selectors: {
    '&:after': {
      content: '',
      position: 'absolute',
      top: 'calc(50% + 12px)',
      left: 0,
      display: 'block',
      width: '100%',
      height: 1,
      background: `linear-gradient(90deg, ${cssVariables.color.outerSpace.hex} 0, ${getRgba(
        cssVariables.color.outerSpace.rgb,
        0.1
      )} 50%, ${cssVariables.color.outerSpace.hex} 100%)`,
      backgroundSize: '200% 100%',
      zIndex: 4,
      animation: `${animationhomeConceptDescriptionList_contentsAfter} 6s infinite linear`,

      '@media': {
        [getMediaQuery('sm')]: {
          top: '50%',
        },

        [getMediaQuery('md')]: {
          top: 'calc(50% + 12px)',
        },

        [getMediaQuery('xl')]: {
          top: '50%',
        },
      },
    },
  },
})

export const homeConceptDescriptionList_box = style({
  maxWidth: 320,
  marginLeft: 'auto',
  position: 'relative',
  zIndex: 7,
})

export const homeConceptDescriptionList_subTitle = style({
  display: 'block',
  fontSize: getFontSize(14),

  '@media': {
    [getMediaQuery('sm')]: {
      position: 'absolute',
      bottom: 'calc(50% + 4px)',
      right: 'calc(100% + 8px)',
      whiteSpace: 'nowrap',
    },

    [getMediaQuery('md')]: {
      position: 'static',
      whiteSpace: 'normal',
    },

    [getMediaQuery('xl')]: {
      position: 'absolute',
      bottom: 'calc(50% + 4px)',
      right: 'calc(100% + 8px)',
      whiteSpace: 'nowrap',
    },
  },
})

export const homeConceptDescriptionListTitle = style({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  fontSize: getFontSize(14),
  fontWeight: cssVariables.font.weight.bold,
  marginTop: 4,
  backgroundColor: cssVariables.color.white.hex,
  border: `1px solid ${cssVariables.color.outerSpace.hex}`,
  padding: 12,
  textAlign: 'center',
})

export const homeConceptDescriptionListTitle_text = style({
  display: 'block',
})

export const homeConceptDescriptionBottom = style({
  paddingTop: 40,
  marginTop: 8,
  position: 'relative',
  zIndex: 3,
})

export const homeConceptDescriptionBottomIcon = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

const animationHomeConceptDescriptionBottomIcon_icon = keyframes({
  '0%': {
    backgroundPosition: '0 0',
  },
  '100%': {
    backgroundPosition: '0 -200%',
  },
})

export const homeConceptDescriptionBottomIcon_icon = style({
  clipPath: 'polygon(0 0, 100% 0, 50% 100%)',
  width: 92,
  height: 24,
  background: `linear-gradient(180deg, ${cssVariables.color.alto.hex} 0, ${cssVariables.color.concrete.hex} 50%, ${cssVariables.color.alto.hex} 100%)`,
  backgroundSize: '100% 200%',
  display: 'block',
  animation: `${animationHomeConceptDescriptionBottomIcon_icon} 3s infinite linear`,
})

export const homeConceptDescriptionBottomMessage = style({
  marginTop: 16,

  '@media': {
    [getMediaQuery('sm')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
})

export const homeConceptDescriptionBottomMessage_container = style({
  padding: 16,
  backgroundColor: cssVariables.color.aeroBlue.hex,
  borderRadius: 6,

  '@media': {
    [getMediaQuery('sm')]: {
      padding: '16px 40px',
    },
  },
})

export const homeConceptDescriptionBottomMessage_paragraph = style({
  textAlign: 'center',
  fontWeight: cssVariables.font.weight.bold,
  fontSize: getFontSize(16),
})

export const homeCollaboration = style({
  padding: '40px 0 80px',
})

export const homeCollaboration_container = style({})

export const homeCollaborationTitle = style({
  overflow: 'hidden',
})

export const homeCollaborationTitle_items = style({
  display: 'flex',
  alignItems: 'center',
  margin: getMarginListItems(16),
  flexWrap: 'wrap',
})

export const homeCollaborationTitle_item = style({
  padding: getPaddingListItem(16),
  display: 'flex',
  alignItems: 'center',
})

export const homeCollaborationTitle_image = style({})

export const homeCollaborationTitle_text = style({
  display: 'block',
  fontSize: getFontSize(24),
  fontWeight: cssVariables.font.weight.bold,
  lineHeight: 1,
})

export const homeCollaboration_paragraph = style({
  marginTop: 16,
})
